var settings = require('ofs/settings');

export default function trackEvent(category, action, opt_label, opt_value, opt_noninteraction) {
  try {
    if (settings.tracking.gactive) {
      if (opt_noninteraction) {
        ga('send', 'event', category, action, opt_label, opt_value, {nonInteraction: 1});
      } else {
        ga('send', 'event', category, action, opt_label, opt_value);
      }
    }
  } catch (e) {
    // Do we care?
  }
}



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/utils/trackEvent.js
 **/